"use client";
/**
 * Returns a function that calls the provided `back` function when triggered.
 * @param {Function} back - The function to call when the back action is triggered.
 * @returns {Function} A function that triggers the back action.
 */
export const useHandleBack = (back) => {
    return (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        back();
    };
};
